import { Link } from "react-router-dom";
import ReservationForm from "../components/reservation/reservationform";
import { HoursList } from "../components/site/Blocks";
import { CONTACT } from "../config/location";

// Mobil: Überschrift, kurzer Text, gleich danach das Formular; Telefon und Zeiten darunter.
// Desktop: Text und Zeiten links, Formular rechts über beide Zeilen.
const Reservation = () => (
    <section className="sec page-head grid-3w max-desk:pt-[112px] pb-[88px] desk:pb-[120px]">
        <div
            className="eyebrow sticky-label desk:row-span-2 desk:!top-[160px] hero-in"
            style={{ animationDelay: ".1s" }}
        >
            Reservierung
        </div>
        <div className="hero-in" style={{ animationDelay: ".25s" }}>
            <h1 className="h1-page mb-6 !text-[clamp(44px,5.5vw,78px)] xwide:!text-[clamp(78px,4vw,100px)]">
                Tisch reservieren
            </h1>
            <p className="lead m-0 max-w-[440px]">
                Füllen Sie das Formular aus, wir bestätigen Ihre Reservierung telefonisch oder per E-Mail. Für heute
                oder morgen rufen Sie bitte direkt an
                <span className="desk:hidden">
                    :{" "}
                    <a href={CONTACT.phoneHref} className="underline">
                        {CONTACT.phone}
                    </a>
                </span>
                .
            </p>
        </div>
        <div className="mt-4 desk:mt-0 desk:col-start-3 desk:row-start-1 desk:row-span-2">
            <ReservationForm />
        </div>
        <div className="mt-10 desk:mt-0 desk:col-start-2 desk:row-start-2">
            <a
                href={CONTACT.phoneHref}
                className="inline-flex border-b border-forest pb-1.5 font-caslon text-[28px] no-underline"
            >
                {CONTACT.phone}
            </a>
            <div className="mt-14">
                <HoursList withNote={false} className="!text-[15px] max-w-[420px]" />
                <div className="mt-3.5 max-w-[420px] text-sm text-forest/70">
                    Warme Küche bis 21:30 Uhr, sonntags bis 20:30 Uhr. Online reservieren Sie bis 9 Personen. Gruppen
                    ab 10 Personen und Feiern bitte über{" "}
                    <Link to="/feiern" className="underline">
                        Feiern
                    </Link>{" "}
                    anfragen, ab 20 Personen auch samstagmittags.
                </div>
            </div>
        </div>
    </section>
);

export default Reservation;
